const myLocalStorage = (function _() {
  return {
    set(key: string, value: any) {
      localStorage.setItem(key, JSON.stringify(value))
    },
    get(key: string) {
      const data = localStorage[key]

      return (data && JSON.parse(data)) || undefined
    },
    remove(key: string) {
      localStorage.removeItem(key)
    },
  }
})()

export default myLocalStorage
